export const label = 'font-medium block text-base font-body text-textMid';
export const spacer = 'mt-5';
